export const ModalRegisterTranslationsCs = {
  Registration: 'Registrace',
  Authorization: 'Autorizace',
  'Register with phone number or email':
    'Registrovat se pomocí telefonního čísla nebo e-mailu',
  Email: 'E-mail',
  'Phone Number': 'Telefonní číslo',
  Or: 'Nebo',
  Facebook: 'Facebook',
  Google: 'Google',
  Other: 'Ostatní',
};
